import React from 'react';
import css from './ListTitle.module.scss';

/**
 * Titre bicolore (titre en capitales + sous-titre en script).
 *
 * `tag` permet d'en faire le titre principal d'une page (`h1`) sans dupliquer
 * les styles ; il reste un `h2` par défaut pour tous les usages existants.
 */
const ListTitle = ({title, subtitle, align, size, subSize, customClassTitle, customClassSubtitle, tag: Tag = 'h2'}) => {

    return (
        <Tag className={`${css.title} ${customClassTitle}`}
            style={{fontSize: size, textAlign: align}}
        >
            {title}
            <span className={customClassSubtitle}
                  style={{fontSize: subSize}}
            >{subtitle}</span>
        </Tag>
    );
};

export default ListTitle;
